import axiosInstance from "../axiosInstance";

import type { BucketlistListParams, BucketlistListResponse, BucketlistStats, BucketlistStatsParams, BucketlistTrend, BucketlistTrendParams } from "../types/bucketlist.types";

const BASE = "/server/buccl_user/api/v1/admin/bucketlist/";

export const bucketlistService = {
  /** 카테고리별 등록/달성 집계 통계 */
  stats: (params?: BucketlistStatsParams) => axiosInstance.get<BucketlistStats>(`${BASE}stats/`, { params }),

  /** 신규 등록 수 시계열 추이 (기본 월별, 최근 12개월) */
  trend: (params?: BucketlistTrendParams) => axiosInstance.get<BucketlistTrend>(`${BASE}trend/`, { params }),

  /** 카테고리 드릴다운 목록 (페이지네이션·필터) */
  list: (params?: BucketlistListParams) => axiosInstance.get<BucketlistListResponse>(BASE, { params }),
};
